import 'objectFitPolyfill';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';

import './views/menu';
import './views/breadcrumbs';

import './view-initalizer';
